/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2019 Bulb Inc.  For more information, please email contact@hellobulb.com.
*
*
*                _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*
*/

/**
* Controller to handle the 'sign in header state' page.
*/
angular.module('bulbApp.authModule')
  .controller('BulbHeaderController', [
    '$cookies', '$stateParams', '$window', '$translate', 'BulbAuthService',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    BulbHeaderController,
  ]);

function BulbHeaderController($cookies, $stateParams, $window, $translate, BulbAuthService) {

  this.currentUser = BulbAuthService.currentUser;

  /**
   * Language helper methods.
   */
  this.languages = $translate.languages;
  this.languagesList = $translate.getLanguagesList();
  this.getLanguage = $translate.getLanguage;
  this.getLanguageAsString = $translate.localeToString;

  // Need to check if there is an error attached to the query param, if so we need this data within the header.html
  this.isErrorScreen = $stateParams.error;
  // Boolean to check if our app is running from icev url
  this.icev = $stateParams.icev;
  this.exp = $stateParams.exp;

  // Set the language in angular-translate and then reload the state so that the locale is applied through-out
  // the app.
  this.setLanguage = function setLanguage(selection) {
    const selectedLanguage = (selection.selectedOption) ? selection.selectedOption : selection;
    if (selectedLanguage !== $translate.getLanguage()) {
      $translate.use(selectedLanguage);
      $cookies.put('language', selectedLanguage, {
        secure: true,
        samesite: 'None',
      });
      // Need to perform a full reload here for the language to take effect.
      $window.location.reload();
    }
  };

  // Redirect the user back to the marketing page if they click the bulb logo
  this.handleBulbLogoClick = function handleBulbLogoClick() {
    // eslint-disable-next-line no-param-reassign
    $window.location.href = '//bulbapp.com';
  };

}
